import { config } from '../config/config';
import { User, Guard, CacheReq } from './';
import axios from 'axios';
import dayjs from '../config/dayjs';
import { queryClient } from '../helpers/queryClient';
import { TeamDataResponse } from '../../interfaces/Results';
import { TeamsCacheKey } from '../constants/keyCache';

export default class Teams extends CacheReq {
  private url: string = config.armcareServerUrl;
  private urlNew: string = config.armcareNewServerUrl;
  private user = new User();
  private GUARD = new Guard();

  constructor(){
    super();
    this.GetMyTeams = this.GetMyTeams.bind(this);
  }

  public async GetMyTeams (all: boolean = true, page: number = 1) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/team?all=${all}&page=${page}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data?.teams) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetTeamCSV (orgId: string, isTeam: boolean = true, onlyAllData?: boolean) {
    const credentials = this.user.GetUserCredentials() as any;
    let url;
    if (isTeam) {
      url = `${this.url}/api/v2/player/csv?orgId=${orgId}${onlyAllData ? '&onlyAllData=true' : ''}`;
    } else {
      url = `${this.url}/api/v2/player/csv?allOrg=1${onlyAllData ? '&onlyAllData=true' : ''}`;
    }
    if (credentials.status) {
      const token = credentials.data.access_token;
      try {
        /* const response = await fetch(url, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);

        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }*/
        const response = await axios.get(url, {
          method: 'GET',
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob', // important
        });
        const now = dayjs();
        const urlDownload = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = urlDownload;
        const fileExtension = onlyAllData ? 'csv' : 'xlsx'
        link.setAttribute('download', `Daily Log ${now.format('MM-DD-YYYY h-m-s')}.${fileExtension}`);
        document.body.appendChild(link);
        link.click();
        return { status: true };
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
  public async GetPlayersOfAteam (all: boolean = true, page: number = 1, teamId: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/player-team?all=${all}&page=${page}${teamId ? `&team=${teamId}` : ''}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data?.meta) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetSummary (reportType: string = 'Summary', team: string = '') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          reportType,
        },
      };
      if (team) {
        Object.defineProperty(body.data, 'team', { value: team, writable: true, configurable: true, enumerable: true });
      }

      try {
        const response = await fetch(`${this.url}/api/v2/summary-report`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['summary-report']) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetExams (
    team: string = '',
    alert: string = '',
    players: string = '',
    page: number = 1,
    limit: number = 20,
    sortBy: string = 'date',
    sortOrder: string = 'desc',
    playerNameSearch: string = ''
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          web: 'true',
          ...(team && { team }),
          ...(alert && { alert }),
          ...(players && { playerGroup: players }),
          ...(playerNameSearch && { search: playerNameSearch }),
          page: page.toString(),
          limit: limit.toString(),
          sortBy,
          sortOrder
        });

        const response = await fetch(
          `${this.url}/api/v2/player-summary?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['records']) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetExamsTeamAverage (
    team: string = '',
    players: string = '',
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          web: 'true',
          ...(team && { team }),
          ...(players && { playerGroup: players }),
        });

        const response = await fetch(
          `${this.url}/api/v2/player-summary-total-average?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['teamAverage']) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetExamsFromPlayer (playerId: string = '', averageCriteria: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(
          `${this.url}/api/v2/player-summary?web=true${playerId ? `&playerId=${playerId}` : ''}${averageCriteria ? `&average_criteria=${averageCriteria}` : ''
          }`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        //pending to refine
        if (data.status) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetPostExams (
    team: string = '',
    players: string = '',
    page: number = 1,
    limit: number = 20,
    sortBy: string = 'date',
    sortOrder: string = 'desc',
    playerNameSearch: string = ''
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          ...(team && { teamId: team }),
          ...(players && { position: players }),
          ...(playerNameSearch && { search: playerNameSearch }),
          page: page.toString(),
          limit: limit.toString(),
          sortBy,
          sortOrder
        });

        const response = await fetch(
          `${this.url}/api/v2/post-exams?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetPostExamsTeamAverage (
    team: string = '',
    players: string = ''
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          ...(team && { teamId: team }),
          ...(players && { position: players }),
        });

        const response = await fetch(
          `${this.url}/api/v2/post-exams-total-average?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetPostExamsFromPlayer (playerId: string = '') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/post-exams${playerId ? `?playerId=${playerId}` : ''}`, {
          method: 'GET',
          headers,
        });
        //this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetPrimerExams (
    team: string = '',
    players: string = '',
    page: number = 1,
    limit: number = 20,
    sortBy: string = 'date',
    sortOrder: string = 'desc',
    playerNameSearch: string = ''
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          ...(team && { teamId: team }),
          ...(players && { position: players }),
          ...(playerNameSearch && { search: playerNameSearch }),
          page: page.toString(),
          limit: limit.toString(),
          sortBy,
          sortOrder
        });

        const response = await fetch(
          `${this.url}/api/v2/arm-primers?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetPrimerExamsTeamAverage (
    team: string = '',
    players: string = '',
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          ...(team && { teamId: team }),
          ...(players && { position: players }),
        });

        const response = await fetch(
          `${this.url}/api/v2/arm-primers-total-average?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetPrimerExamsFromPlayer (playerId: string = '') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/arm-primers${playerId ? `?playerId=${playerId}` : ''}`, {
          method: 'GET',
          headers,
        });
        //this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetKeyMetrics (
    team: string = '',
    players: string = '',
    page: number = 1,
    limit: number = 20,
    sortBy: string = 'date',
    sortOrder: string = 'desc',
    playerNameSearch: string = ''
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const queryParams = new URLSearchParams({
          ...(team && { teamId: team }),
          ...(players && { position: players }),
          page: page.toString(),
          limit: limit.toString(),
          ...(sortBy && { sortBy }),
          ...(sortOrder && { sortOrder }),
          ...(playerNameSearch && { search: playerNameSearch }),
        });

        const response = await fetch(
          `${this.url}/api/v2/all-new-keymetrics?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );

        this.GUARD.verifyError(response);
        const data = await response.json();

        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }


  public async GetKeyMetricsPlayer (player_id: string = '') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/all-new-keymetrics?player_id=${player_id}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetActionItems (team: string = '', players: string = '') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(
          `${this.url}/api/v2/action-items${team ? `?teamId=${team}` : '?'}${players ? `&position=${players}` : ''}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (Object.keys(data).length > 0) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetPlayerAccountabilityExams (playerId: string = '', flag: boolean = false) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/accountability${playerId ? `?playerId=${playerId}` : ''}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();

        //pending to refine
        if (flag) return [data];
        if (data.state) {
          return data;
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetAccountabilityExams (
    team: string = '',
    players: string = '',
    playerName: string = '',
    page: number = 1,
    limit: number = 20,
    sortBy: string = 'firstName',
    sortOrder: string = 'desc',
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          ...(team && { team }),
          ...(players && { playerGroup: players }),
          ...(playerName && { search: playerName }),
          page: page.toString(),
          limit: limit.toString(),
          sortBy,
          sortOrder
        });
        const response = await fetch(
          `${this.url}/api/v2/accountability?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['records']) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetAccountabilityTeamAverage (
    team: string = '',
    players: string = '',
    playerName: string = '',
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          ...(team && { team }),
          ...(players && { playerGroup: players })
        });
        const response = await fetch(
          `${this.url}/api/v2/accountability-total-average?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['teamAverage']) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }


  public async GetWellnessRecords (
    team: string = '',
    playersGroup: string = '',
    playerName: string = '',
    page: number = 1,
    limit: number = 20,
    sortBy: string = 'date',
    sortOrder: string = 'desc',
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          ...(team && { team }),
          ...(playersGroup && { playerGroup: playersGroup }),
          ...(playerName && { search: playerName }),
          page: page.toString(),
          limit: limit.toString(),
          sortBy,
          sortOrder
        });
        const response = await fetch(
          `${this.url}/api/v2/wellness?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['records']) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetWellnessRecordsTeamAverage (
    team: string = '',
    playersGroup: string = '',
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const queryParams = new URLSearchParams({
          ...(team && { team }),
          ...(playersGroup && { playerGroup: playersGroup })
        });
        const response = await fetch(
          `${this.url}/api/v2/wellness-total-average?${queryParams.toString()}`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['teamAverage']) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetWellnessRecordsFromPlayer (playerId: string = '') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/wellness${playerId ? `?playerId=${playerId}` : ''}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.status || data.state) {
          return data;
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
  public async GetScorecardRecords (team: string = '', playersGroup: string = '', playerName: string = '') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(
          `${this.url}/api/v2/scorecard${team ? `?team=${team}` : '?'}${playerName ? `&player=${playerName}` : ''}${playersGroup ? `&playerGroup=${playersGroup}` : ''
          }`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
  public async GetScorecardFromPlayer (playerId: string = '') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/scorecard${playerId ? `?playerId=${playerId}` : ''}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        //pending to refine
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
  public async GetLeaderboardRecords (
    team: string = '',
    playersGroup: string = '',
    playerName: string = '',
    metric: string = '',
    period: string = '',
    start: Date,
    end: Date,
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(
          `${this.url}/api/v2/player-leader-board${team ? `?team=${team}` : '?'}${playerName ? `&player=${playerName}` : ''}${playersGroup ? `&playerGroup=${playersGroup}` : ''
          }${metric ? `&metric=${metric}` : ''}${period ? `&period=${period}` : ''}${period === 'custom' ? `&start=${start}&end=${end}` : ''
          }`,
          {
            method: 'GET',
            headers,
          },
        );
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data: data.data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
  public async FetchSelectedPlayerInfo (playerId: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/player/${playerId}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();

        if (data.success) {
          data.data._id = playerId;
          return data;
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    }
  }

  public async UpdatePlayerInvitation (invitationId: string, playerObject: object) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: { ...playerObject },
      };

      try {
        const response = await fetch(`${this.url}/api/v2/invitation-freemium/${invitationId}`, {
          method: 'PUT',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return data;
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async DeletePlayerInvitation (invitationId: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/invitation/${invitationId}`, {
          method: 'DELETE',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async InviteAplayerToAteam (firstName: string, lastName: string, email: string, team: string, requestType: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          players: [
            {
              firstName,
              lastName,
              email,
              team,
              requestType,
            },
          ],
        },
      };

      try {
        const response = await fetch(`${this.url}/api/v2/invitation`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['invitations']) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async ValidateEmailsBulk (dataToSend) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          players: dataToSend
        },
      };
      try {
        const response = await fetch(`${this.url}/api/v2/invitation`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['invitations']) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async InviteMultiplePlayersToAteam (players: Array<any>) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          players,
        },
      };

      try {
        const response = await fetch(`${this.url}/api/v2/invitation-freemium`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['invitations']) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async InviteByBulkUpload (players: Array<any>) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          players,
        },
      };

      try {
        const response = await fetch(`${this.urlNew}/v1/invitation`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.statusCode < 300) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async InviteAcoach (firstName: string, lastName: string, email: string, team: Array<any>, role: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          coachs: [
            {
              firstName,
              lastName,
              email,
              teams: team.length ? [...team.map(el => el._id)] : [],
              role,
            },
          ],
        },
      };

      try {
        const response = await fetch(`${this.url}/api/v2/coach-invitation`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['coach_invitations']) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async UpdateCoachInvitation (invitationId: string, coach: Array<any>) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: { ...coach },
      };

      try {
        const response = await fetch(`${this.url}/api/v2/coach-invitation/${invitationId}`, {
          method: 'PUT',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['coach-invitation']) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async DeleteCoachInvitation (invitationId: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/coach-invitation/${invitationId}`, {
          method: 'DELETE',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async InviteMultipleCoaches (coachs: Array<any>) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          coachs,
        },
      };

      try {
        const response = await fetch(`${this.url}/api/v2/coach-invitation`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['coach_invitations']) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async createTeam (name: string, color: string, initials: string, city: string, state: string, picture: string = '') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          name,
          color,
          initials,
          city,
          state,
        },
      };
      if (picture) {
        Object.defineProperty(body.data, 'picture', { value: picture, writable: true, configurable: true, enumerable: true });
      }
      try {
        const response = await fetch(`${this.url}/api/v2/team`, {
          method: 'POST',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['team']) {
          return { status: true, data };
        } else {
          return { status: false, data };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async updateTeam (
    name: string,
    color: string,
    initials: string,
    teamId: string,
    city: string,
    state: string,
    players: Array<string>,
    picture: string = '',
  ) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        data: {
          name,
          color,
          initials,
          city,
          state,
          players,
        },
      };
      if (picture) {
        Object.defineProperty(body.data, 'picture', { value: picture, writable: true, configurable: true, enumerable: true });
      }
      try {
        const response = await fetch(`${this.url}/api/v2/team/${teamId}`, {
          method: 'PUT',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data['_id']) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async deleteTeam (teamId: string) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/team/${teamId}`, {
          method: 'DELETE',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetStates () {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/state`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data[0]._id) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async GetCities (state = '5f973242980e091d994c803c') {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      try {
        const response = await fetch(`${this.url}/api/v2/city?state=${state}`, {
          method: 'GET',
          headers,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data[0]._id) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async UpdateVelocity (playerId, velocity) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });
      const body = {
        velocity: velocity,
        playerId: playerId,
      };
      try {
        const response = await fetch(`${this.url}/api/v2/update-velocity-for-player?`, {
          method: 'PUT',
          headers,
          body: JSON.stringify(body),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.success) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async HidePlayer(playerId, action) {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/player-exclude-from-avg/${playerId}`, {
          method: 'PUT',
          headers,
          body: JSON.stringify({
            data: {
              excludeFromExamAvg: action === 'exclude',
            },
          }),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.player) {
          return { status: true };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async HideExam (playerId, action, table) {
    let param;
    if (table === 'fresh') {
      param = 'exam-exclude-fresh-from-avg';
    } else if (table === 'post') {
      param = 'exam-exclude-post-from-avg';
    } else {
      param = 'arm-primer-exclude-from-avg';
    }

    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/${param}/${playerId}`, {
          method: 'PUT',
          headers,
          body: JSON.stringify({
            data: {
              excludeFromExamAvg: action,
            },
          }),
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.exam || data['arm-primer']) {
          return { status: true };
        } else {
          return { status: false };
        }
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public async SetFirstLogin () {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      });

      try {
        const response = await fetch(`${this.url}/api/v2/settings`, {
          method: 'PUT',
          headers,
          body: JSON.stringify({
            data: {
              isFirstLogin: false,
            },
          }),
        });
        this.GUARD.verifyError(response);
      } catch (e) {
        console.log(e);
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }
}
